{
  "about": [
    {
      "name": "Updated knowledge",
      "description": "They all live tidily together in teams. with your team and information in ",
      "path": "/assets/icons/home/about/book.svg"
    },
    {
      "name": "We are relaible",
      "description": "They all live tidily together in teams. with your team and information in  ",
      "path": "/assets/icons/home/about/handshake.svg"
    },
    {
      "name": "Time mangement",
      "description": "They all live tidily together in teams. with your team and information in ",
      "path": "/assets/icons/home/about/clock.svg"
    }
  ]
}
